<ng-container [formGroup]="formGroup()">
  <div class="relative col-span-2 flex items-center pl-10" [class]="readonly() ? 'text-states-light-white' : colorClasses[colorVariant()]">
    @if (showGradient()) {
      <div
        class="pointer-events-none absolute -bottom-1 -right-full -top-1 left-4 z-[-1] rounded-l-[18px] opacity-20 blur-sm"
        [style.background]="gradientStyles[colorVariant()]"
      ></div>
    }
    <span>{{ rowLabel() }}</span>
  </div>
  <ng-container [ngTemplateOutlet]="isDcm() ? distal : mesial" />
  <lib-input
    class="!h-10 !w-12"
    libPerioActiveToothFormUserInput
    surface="central"
    type="number"
    formControlName="central"
    [activeCursorHint]="isCentralActive()"
    [activeCursorHintColor]="colorVariant()"
    [keepFocused]="true"
    [hideCaret]="true"
    [disableFocusWithinBorder]="true"
    [activeCursorNextStroke]="isNextStroke()"
    [readonly]="readonly()"
    [reversed]="reversed()"
    [fgDisabled]="fgDisabled()"
    [background]="'white'"
  ></lib-input>

  <ng-container [ngTemplateOutlet]="isDcm() ? mesial : distal" />

  <ng-template #distal>
    <lib-input
      class="!h-10 !w-12"
      libPerioActiveToothFormUserInput
      surface="distal"
      type="number"
      formControlName="distal"
      [activeCursorHint]="isDistalActive()"
      [activeCursorHintColor]="colorVariant()"
      [keepFocused]="true"
      [hideCaret]="true"
      [disableFocusWithinBorder]="true"
      [activeCursorNextStroke]="isNextStroke()"
      [readonly]="readonly()"
      [reversed]="reversed()"
      [fgDisabled]="fgDisabled()"
      [disabledRecession]="disabledRecession()"
      [background]="'white'"
    ></lib-input>
  </ng-template>

  <ng-template #mesial>
    <lib-input
      class="!h-10 !w-12"
      libPerioActiveToothFormUserInput
      surface="mesial"
      [activeCursorHint]="isMesialActive()"
      type="number"
      formControlName="mesial"
      [activeCursorHintColor]="colorVariant()"
      [keepFocused]="true"
      [hideCaret]="true"
      [disableFocusWithinBorder]="true"
      [activeCursorNextStroke]="isNextStroke()"
      [readonly]="readonly()"
      [reversed]="reversed()"
      [fgDisabled]="fgDisabled()"
      [disabledRecession]="disabledRecession()"
      [background]="'white'"
    ></lib-input> </ng-template
></ng-container>
